import { useSearchResults } from "@apiHooks/useSearchResults";
import {
    AskQuestionLabel,
    Button,
    FCX,
    Popup,
    ToolSearch as PlatformToolSearch,
    ToolSearchContent,
    ToolSearchHeader,
    ToolSearchInput,
} from "@datassential/platform-ui-lib";
import { useCallback, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import cn from "classnames";
import { IoClose } from "react-icons/io5";
import { BsStars } from "react-icons/bs";
import { SearchResults } from "@models/SearchResults";
import { currentCountrySelector } from "@selectors/countries.selector";
import SearchResultsSections from "./SearchResults/SearchResultsSections";
import SuggestedSearches from "./SuggestedSearches";
import RecentSearches from "./RecentSearches";
import { createRecentSearches } from "@apiHooks/useRecentSearches";

const ToolSearch: FCX<{
    isOpen: boolean;
    close: () => void;
}> = ({
    isOpen,
    close,
    className,
    testId,
}) => {
    const [search, setSearch] = useState<string>('');

    const currentCountry = useSelector(currentCountrySelector);
    const searchResults = useSearchResults(currentCountry, search);
    const { data: { data } } = search.trim() ? searchResults : { data: new SearchResults() };

    const applySearch = useCallback((text = '') => {
        createRecentSearches(text || search)
    }, [search]);

    const handleSearchClick = useCallback((text: string) => {
        setSearch(text);
        applySearch(text);
    }, [applySearch]);

    const submitEl = useMemo(() => {
        if (!search.trim().length) return null;

        return (
            <Button
                className="ToolSearch__aiSearchButton appears"
                onClick={() => applySearch(search)}
            >
                {/* @ts-ignore */}
                <BsStars/>&nbsp;AI Search
            </Button>
        );
    }, [search, applySearch]);

    const closeToolSearch = useCallback(() => {
        setSearch("");
        close();
    }, [close]);

    const filteredSections = useMemo(() => data.filter(section => section.items.length > 0), [data]);

    return (
        <Popup
            isOpened={isOpen}
            close={closeToolSearch}
            closeOnEsc
            noWrapper
            testId={testId}
        >
            <PlatformToolSearch
                className={cn(
                    "ToolSearch",
                    className
                )}
                testId={"blockToolSearch"}
            >
                <ToolSearchHeader
                    closeEl={
                        <div
                            className="ToolSearch__close"
                            onClick={closeToolSearch}
                        >
                            {/* @ts-ignore */}
                            <IoClose/>
                        </div>
                    }
                    className="appears-bottom"
                >
                    <AskQuestionLabel className="ToolSearch__question-label ToolSearchQuestionLabel">
                        or type in any food, flavor, or beverage to get started.
                    </AskQuestionLabel>
                    <SuggestedSearches onSearchClick={handleSearchClick} />
                    <ToolSearchInput
                        className="ToolSearch__input ToolSearchInput"
                        value={search}
                        onChange={(e) => setSearch(e.currentTarget.value)}
                        submitEl={submitEl}
                    />
                </ToolSearchHeader>
                <ToolSearchContent className="ToolSearch__content appears">
                    <SearchResultsSections sections={filteredSections} search={search.trim()} />
                    <RecentSearches
                        className={cn(filteredSections.length && "is-hidden")}
                        onSearchClick={handleSearchClick}
                    />
                </ToolSearchContent>
            </PlatformToolSearch>
        </Popup>
    );
};

export default ToolSearch;